package org.teddapp.project.ui

import androidx.compose.ui.input.pointer.PointerIcon

// Sans flèche double commune à la plateforme : la main dit déjà qu'on peut saisir.
actual val ResizeHorizontalCursor: PointerIcon = PointerIcon.Hand
